import gql from 'graphql-tag'

export default gql`
mutation reportEventCount($firstDate: String!, $endDate: String!) {
    reportEventCount(firstDate: $firstDate, endDate: $endDate){
      url
      fileName
    }
  }
`